import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dimmer,
  Grid,
  Header,
  Loader,
  Modal,
  Segment,
  Table,
  Icon,
} from 'semantic-ui-react';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';

import SearchFilter from '../../components/SearchFilter';
import PageNav from '../../components/PageNav';
import ListItem from '../../components/ListItem';

export default class ProjectsList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onSelect: PropTypes.func,
    onCheck: PropTypes.func,
    selected: PropTypes.arrayOf(PropTypes.object),
    companyBranchID: PropTypes.number,
    userBranchProjects: PropTypes.arrayOf(PropTypes.object),
  }
  static defaultProps = {
    companyBranchID: 0,
  }
  static getPropsToState = (props) => {
    const selected = [].concat(props.selected);
    return {
      selected,
    };
  }
  constructor(props) {
    super(props);
    const state = ProjectsList.getPropsToState(props);
    this.state = {
      ...state,
      data: [],
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      currentPage: 1,
      query: {},
      search: '',
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = ProjectsList.getPropsToState(nextProps);
    if (nextProps.open === true && this.props.open !== nextProps.open) {
      this.fetchProjects();
    }
    this.setState(state);
  }
  setProjects(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getCoverPicture = (pictures) => {
    if (pictures && pictures.length > 0 && pictures.some(pp => pp.isCover === true)) {
      return pictures.find(pp => pp.isCover === true).picture;
    }
    return null;
  }
  async fetchProjects() {
    await this.setLoading(true);
    await this.setProjects([]);
    const { store } = this.context;
    const query = Object.assign({
      viewAll: true,
      page: this.state.currentPage || 1,
      search: this.state.search || '',
    });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setProjects(data);
      if (this.state.data.length < 1 && query.page > 1) {
        this.setState({ currentPage: 1 }, () => {
          this.fetchProjects();
        });
      } else {
        // handle token.. etc
        await this.setComponentState({
          count,
          limit,
          offset,
        });
      }
    }
    await this.setLoading(false);
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, this.state.selected);
    }
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleChangeTab = (e, { name, value }) => {
    const currentTab = name || value;
    this.setState({ currentTab }, () => {
      this.fetchProjects();
    });
  }
  handleOnSelect = (e, project) => {
    const { selected } = this.state;
    const index = selected.findIndex(b => b.id === project.id);
    if (index < 0) {
      if (this.handleOnCheck(project)) {
        return;
      }
      selected.push(project);
    } else {
      selected.splice(index, 1);
    }
    this.setState({ selected }, () => {
      if (this.props.onSelect) {
        this.props.onSelect(project);
      }
    });
  }
  handleOnCheck = (project) => {
    if (this.props.onCheck) {
      const { selected } = this.state;
      return this.props.onCheck(project, selected);
    }
    return false;
  }
  handleClearFilter = () => {
    this.setState({ search: '' }, () => {
      this.fetchProjects();
    });
  }
  handleOnChange = (search) => {
    this.setState({ search }, () => {
      this.fetchProjects();
    });
  }
  handleChangePage = (currentPage) => {
    this.setState({ currentPage }, () => {
      this.fetchProjects();
    });
  }
  checkProjectOwner = (project) => {
    if (
      this.props.companyBranchID &&
      project.maOwnerCompanyBranchID === this.props.companyBranchID
    ) {
      return true;
    }
    return false;
  }
  checkUserBranchProject = (project) => {
    if (this.props.userBranchProjects) {
      const match = this.props.userBranchProjects.find(d => d.id === project.id);
      if (match) {
        return true;
      }
    }
    return false;
  }
  render() {
    return (
      <Modal
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
        className="items-list-modal"
      >
        <Header
          icon="add"
          content="Add projects"
        />
        <Modal.Content>
          <Grid verticalAlign="middle" columns={1}>
            <Grid.Column>
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
              />
            </Grid.Column>
            <Grid.Column className="list">
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={this.state.loading && this.state.data.length > 0}
              >
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              {
                this.state.data.length > 0 ? (
                  <Table unstackable>
                    <Table.Body>
                      {
                        this.state.data.map((project, idx) => (
                          <Table.Row
                            key={idx}
                            positive={
                              this.state.selected.some(s => s.id === project.id) ||
                              this.checkUserBranchProject(project)
                            }
                            active={this.handleOnCheck(project)}
                          >
                            <Table.Cell>
                              <ListItem
                                item={project}
                                onClick={this.handleOnSelect}
                                selected={this.state.selected.some(s => s.id === project.id)}
                                disabled={
                                  this.handleOnCheck(project) ||
                                  this.checkProjectOwner(project) ||
                                  this.checkUserBranchProject(project)
                                }
                                header={(item) => {
                                  if (this.checkProjectOwner(project)) {
                                    return <span>{item.name} <Icon name="lock" fitted /><i> <small>Owner</small></i></span>;
                                  }
                                  if (this.checkUserBranchProject(project)) {
                                    return <span>{item.name} <Icon name="eye" fitted /><i> <small>Business Unit Access</small></i></span>;
                                  }
                                  return item.name;
                                }}
                                subheader={item => item.status.name}
                                checkable
                              />
                            </Table.Cell>
                          </Table.Row>
                        ))
                      }
                    </Table.Body>
                  </Table>
                ) : (
                  <Segment textAlign="center">
                    {
                      this.state.loading ?
                        <Loader active inline="centered">Loading</Loader>
                      : 'No project found.'
                    }
                  </Segment>
                )
              }
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <PageNav
            currentPage={this.state.currentPage}
            count={this.state.count}
            limit={this.state.limit}
            offset={this.state.offset}
            dataSize={this.state.data.length}
            loading={this.state.loading}
            onChange={this.handleChangePage}
            hideDropdown
          />
          <Button
            primary
            onClick={this.handleOnComfirm}
            icon="checkmark"
            content="Add"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/ProjectsList.jsx